import { render, staticRenderFns } from "./TrashView.vue?vue&type=template&id=364863d6&"
import script from "./TrashView.vue?vue&type=script&lang=js&"
export * from "./TrashView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports